/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { ReviewNestedService } from './ReviewNestedService'
import {
  ReviewNestedServiceFromJSON,
  ReviewNestedServiceFromJSONTyped,
  ReviewNestedServiceToJSON,
} from './ReviewNestedService'

/**
 *
 * @export
 * @interface Review
 */
export interface Review {
  /**
   *
   * @type {number}
   * @memberof Review
   */
  readonly id: number
  /**
   *
   * @type {number}
   * @memberof Review
   */
  rating?: number
  /**
   *
   * @type {string}
   * @memberof Review
   */
  author?: string | null
  /**
   *
   * @type {string}
   * @memberof Review
   */
  publishedAt?: string | null
  /**
   *
   * @type {boolean}
   * @memberof Review
   */
  isPublished?: boolean
  /**
   *
   * @type {ReviewNestedService}
   * @memberof Review
   */
  readonly service: ReviewNestedService
  /**
   *
   * @type {string}
   * @memberof Review
   */
  text?: string | null
}

/**
 * Check if a given object implements the Review interface.
 */
export function instanceOfReview(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'id' in value
  isInstance = isInstance && 'service' in value

  return isInstance
}

export function ReviewFromJSON(json: any): Review {
  return ReviewFromJSONTyped(json, false)
}

export function ReviewFromJSONTyped(json: any, ignoreDiscriminator: boolean): Review {
  if (json === undefined || json === null) {
    return json
  }
  return {
    id: json['id'],
    rating: !exists(json, 'rating') ? undefined : json['rating'],
    author: !exists(json, 'author') ? undefined : json['author'],
    publishedAt: !exists(json, 'publishedAt') ? undefined : json['publishedAt'],
    isPublished: !exists(json, 'isPublished') ? undefined : json['isPublished'],
    service: ReviewNestedServiceFromJSON(json['service']),
    text: !exists(json, 'text') ? undefined : json['text'],
  }
}

export function ReviewToJSON(value?: Review | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    rating: value.rating,
    author: value.author,
    publishedAt: value.publishedAt,
    isPublished: value.isPublished,
    text: value.text,
  }
}
